<template>
  <div id="appliance">
    <div id="shifting">
      <div class="payment-link-container">
        <capusta-data-view
          :label="$t('receive.transfer')"
          :description="project.payLink"
          @click="onCopy"
        />
      </div>
      <div>
        <button class="settings" @click="$router.push({ name: 'payment.settings' })">
          Settings
        </button>
        <button
          class="qr-code"
          @click="SET_MODAL_PARAMS({ type: 'QR', params: { show: true, bill: { description: project.description }, type: 'project', code: project.code } })"
        >
          QR Code
        </button>
        <button
          class="share"
          @click="SET_MODAL_PARAMS({ type: 'SHARE', params: { show: true, shareInfo: { url: project.payLink, title: `${$t('link.to.pay')} | capusta.space`, description: project.description, showForm: false } } })"
        >
          {{ $t('to.share') }}
        </button>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="!SELECTED_TRANSACTION.owner_id || isDesktop"
        class="bill-created"
      >
        <a
          class="button thin action"
          :class="{
            'disabled': isInactiveProject
          }"
          @click="$router.push({ name: 'Invoicing' })"
        >
          <span>{{ $t('common.create') }}</span>
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import { copyToClipboard } from 'lib/utils/clipboard';

import CapustaDataView from 'modules/CapustaLayout/CapustaDataView';

import ProjectService from 'services/project';

export default {
  name: 'ProjectControl',
  components: {
    CapustaDataView,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isInactiveProject() {
      return ProjectService.checkInactiveStatus(this.project);
    },
    ...mapState([
      'SELECTED_TRANSACTION',
    ]),
    ...mapGetters([
      'isDesktop',
    ]),
  },
  methods: {
    onCopy() {
      copyToClipboard(this.project.payLink);

      this.$alert({
        type: 'ok',
        text: 'link.copied',
      });
    },
    ...mapMutations([
      'SET_MODAL_PARAMS',
    ]),
  },
};
</script>

<style lang="sass" scoped>
  .payment-link-container
    width: 100%
    margin-bottom: 18px
    align-self: stretch

    +respond-to('medium')
      width: 380px
      margin-bottom: 0

  .bill-created
    margin-top: 20px

    +respond-to('medium')
      flex: 1
      margin-top: 0
      margin-left: 20px

    @media (max-width: 860px)
      position: fixed !important
      right: 1.48rem
      bottom: 1.55rem
      z-index: 10
      width: 60px
      height: 60px
      overflow: hidden

      background: linear-gradient(241.39deg, #D650D3 -0.37%, #9B51E0 96%)
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
      border-radius: 100px
      z-index: 500

      &::after
        content: '+'
        color: #fff
        +full-size(0, absolute)
        font-size: 3rem
        text-align: center
        pointer-events: none

      a
        &.button
          opacity: 0

  #appliance
    display: flex
    flex-direction: column

    +respond-to('medium')
      flex-direction: row
      justify-content: space-between

    .card
      +respond-to('medium')
        display: none

      > div
        font-size: 1rem
        font-weight: 600
        position: relative
        overflow: unset
        width: 100%
        margin: 0.08rem
        padding: 1.84rem 1.84rem 1.84rem calc(4.24rem + 1.84rem)
        text-align: left
        color: #C7C7CB
        border-radius: 0.36rem
        background-color: #27283C

        > p
          padding-left: 1.84rem

        &::before
          +pseudo-block
          z-index: -1
          top: -0.08rem
          right: -0.08rem
          bottom: -0.08rem
          left: -0.08rem
          border-radius: 0.36rem
          background-color: transparent

        &::after
          +pseudo-block
          z-index: 0
          top: calc(50% - (4.24rem / 2))
          left: 1.84rem
          width: 4.24rem
          height: 4.24rem
          border-radius: 50%
          background-color: #34A7F9
          background-image: url("~@/assets/img/symbol-telegram-white.svg")
          background-repeat: no-repeat
          background-position: center center
          background-size: 1.84rem

        &:hover
          cursor: pointer
          background-color: #2E3048

          &::before
            background-color: #34A7F9

    > div
      position: relative
      display: flex
      flex-wrap: wrap
      // flex: 1

      &#shifting
        // padding: 20px 0

        +respond-to('medium')
          height: fit-content
          align-items: center
          flex-flow: row
          justify-content: space-between
          padding: 0
          border-radius: 50px

          #{theme('eclipse')} &
            background-color: $pure-white
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)

          #{theme('obsidian')} &
            background-color: #27283C

        p
          display: inline-block
          flex-basis: 100%
          padding: 0
          text-align: left
          border-radius: 2.48rem 0 0 2.48rem

          +respond-to('medium')
            flex-basis: unset
            width: 12rem
            padding-left: 1.42rem

        > form
          display: flex
          flex-grow: 1
          border-radius: 10rem
          background-color: red

          @media (max-width: 767px)
            background-color: transparent !important

          #{theme('eclipse')} &
            background-color: #F0FAF9

          #{theme('obsidian')} &
            background-color: #181822

          > label:not(.label-copy)
            flex-basis: 12rem
            flex-shrink: 0
            order: -1
            padding: 0.84rem

          > input
            padding-left: 0
            color: #7CB342

        > div
          &:last-of-type
            width: 100%
            display: flex
            align-items: center
            // margin-top: 0.64rem
            border-radius: 50px

            #{theme('eclipse')} &
              background-color: $pure-white

            #{theme('obsidian')} &
              background-color: #27283C

            +respond-to('medium')
              width: auto
              position: relative
              margin: 0
              border-top-left-radius: 0
              border-bottom-left-radius: 0

          button
            width: inherit
            height: 2.68rem
            font-size: 0
            line-height: 1.44rem
            text-align: center
            border: 0.08rem solid #000
            border-top: unset
            border-bottom: unset
            background-color: unset
            background-repeat: no-repeat
            background-position: center center
            background-size: 1.44rem
            z-index: 1

            #{theme('eclipse')} &
              border-color: #F4F4F4

            #{theme('obsidian')} &
              border-color: #323346

            +respond-to('medium')
              width: 80px

            &:first-of-type
              border-left: unset

            &:last-of-type
              border-right: unset

            &.copy
              #{theme('eclipse')} &
                background-image: get-icon('copy', #9B51E0)

              #{theme('obsidian')} &
                background-image: get-icon('copy', $pure-white)

              &:hover
                #{theme('eclipse')} &
                  background-image: get-icon('copy', #212121)

                #{theme('obsidian')} &
                  background-image: get-icon('copy', #9B51E0)

            &.settings
              #{theme('eclipse')} &
                background-image: get-icon('settings', #9B51E0)

              #{theme('obsidian')} &
                background-image: get-icon('settings', $pure-white)

              &:hover
                #{theme('eclipse')} &
                  background-image: get-icon('settings', #212121)

                #{theme('obsidian')} &
                  background-image: get-icon('settings', #9B51E0)

            &.qr-code
              #{theme('eclipse')} &
                background-image: get-icon('qr-code', #9B51E0)

              #{theme('obsidian')} &
                background-image: get-icon('qr-code', $pure-white)

              &:hover
                #{theme('eclipse')} &
                  background-image: get-icon('qr-code', #212121)

                #{theme('obsidian')} &
                  background-image: get-icon('qr-code', #9B51E0)

            &.share
              #{theme('eclipse')} &
                background-image: get-icon('share', #9B51E0)

              #{theme('obsidian')} &
                background-image: get-icon('share', $pure-white)

              &:hover
                #{theme('eclipse')} &
                  background-image: get-icon('share', #212121)

                #{theme('obsidian')} &
                  background-image: get-icon('share', #9B51E0)

      a
        width: 100%
        line-height: 1.68rem
</style>
